import { createBirthdayFilterValue, formatMonthDay } from "../helpers";

import { searchDateLike } from "./date";
import type { FilterStrategy } from "./types";

/**
 * Year-agnostic date filter: emits values in `--MM-DD` format that the
 * backend's birthday/month-day SQL path matches against `EXTRACT(month/day)`
 * on the date column. Search step is shared with `dateStrategy`.
 */
export const birthdayStrategy: FilterStrategy = {
  search: searchDateLike,
  isSelected(
    currentValue,
    _optionValue,
    _comparison,
    _numericValue,
    datePreset,
    filterConfig,
  ) {
    if (
      Array.isArray(currentValue) &&
      currentValue.length === 2 &&
      datePreset !== undefined
    ) {
      const expectedValue = createBirthdayFilterValue(
        datePreset.days,
        filterConfig.direction === "future" ? "future" : "past",
      );
      return (
        currentValue[0] === expectedValue[0] &&
        currentValue[1] === expectedValue[1]
      );
    }
    return false;
  },
  toggle(result, _currentValue, filterConfig) {
    if (result.specificDate) {
      const md = formatMonthDay(result.specificDate);
      return { value: [md, md] };
    }
    if (result.datePreset) {
      return {
        value: createBirthdayFilterValue(
          result.datePreset.days,
          filterConfig.direction === "future" ? "future" : "past",
        ),
      };
    }
    return { value: result.optionValue };
  },
};
